export const CURRENCIES_WITH_THOUSAND_DIVISOR = [
  'JOD',
  'OMR',
  'KWD',
  'BHD',
  'IQD',
  'LYD',
  'TND',
];
